import httpRequest from "./httpreq";
import { isFunction, isDefined, normalName, objectCopy } from "../shared/utils";
export const getUsers = (callback) => {
  let opt = {
    cmd: "getUsers",
    token: window.token
  };
  httpRequest(opt, (data) => {
    if (isFunction(callback)) {
      if (data.message === "OK") {
        callback(null, data.obj.users);
      } else {
        callback(new Error("get users error"));
      }
    }
  });
};
export const getDefaultUser = (callback) => {
  let opt = {
    cmd: "getDefaultUser",
    token: window.token
  };
  httpRequest(opt, (data) => {
    if (isFunction(callback)) {
      if (data.message === "OK") {
        callback(null, data.obj.defaultuser);
      } else {
        callback(new Error("get default user error"));
      }
    }
  });
};
/**
 *
 * @param {*} userInfo  {username,password,isadmin}
 * @param {*} callback
 */
export const addUser = (userInfo, callback) => {
  let opt = {
    cmd: "addUser",
    body: userInfo,
    token: window.token
  };
  httpRequest(opt, (data) => {
    if (isFunction(callback)) {
      if (data.message === "OK") {
        callback(null, data.obj);
      } else {
        callback(data.error);
      }
    }
  });
};
/**
 *
 * @param {*} userInfo {sessionuser,username,password,oldpass,isadmin,userid}
 * @param {*} callback
 */
export const updateUser = (userInfo, callback) => {
  let opt = {
    cmd: "updateUser",
    body: userInfo,
    token: window.token
  };

  httpRequest(opt, (data) => {
    if (data.message === "OK") {
      callback(null, data.obj);
    } else {
      callback(data.error);
    }
  });
};
export const delUser = (username, callback) => {
  let opt = {
    cmd: "delUser",
    body: { username },
    token: window.token
  };

  httpRequest(opt, (data) => {
    if (data.message === "OK") {
      callback();
    } else {
      callback(data.error);
    }
  });
};
// var sessionuser = (req.body && req.body.sessionuser) || (req.query && req.query.sessionuser)
// var username = (req.body && req.body.username) || (req.query && req.query.username)
// var password = (req.body && req.body.password) || (req.query && req.query.password)
// var oldpass = (req.body && req.body.oldpass) || (req.query && req.query.oldpass)
// var isadmin = (req.body && req.body.isadmin) || (req.query && req.query.isadmin)
// var userid = (req.body && req.body.userid) || (req.query && req.query.userid)



// WEBPACK FOOTER //
// ./src/services/users.js